const ENDPOINTS = {
    GENERAL_SETTINGS: '/api/general-setting',
    SEO: '/api/seo',
    GET_EXTENSION: '/api/get-extension',
    LOGIN: '/api/login',
    LOGOUT: '/api/logout',
    REGISTER: '/api/register',
    RESET_EMAIL: '/api/password/email',
    RESET_EMAIL_VERIFICATION: '/api/password/verify-code',
    RESET_PASSWORD: '/api/password/reset',
    LANG_KEYS: '/api/language',
    POLICY_PAGES: '/api/policies',
    POLICY: '/api/policy',
    COUNTRIES: '/api/get-countries',
    UPDATE_USER_DATA: '/api/user-data-submit',
    USER_INFO: '/api/user-info',
    AUTHORIZATION: '/api/authorization',
    SEND_CODE: '/api/authorization',
    RESEND_CODE: '/api/resend-verify',
    VERIFY_CODE: '/api/verify',
    UPDATE_PROFILE: '/api/profile-setting',
    CHANGE_PASSWORD: '/api/change-password',
    TWO_FA_SETUP: '/api/twofactor',
    TWO_FA_ENABLE: '/api/twofactor/enable',
    TWO_FA_DISABLE: '/api/twofactor/disable',
    KYC_FORM: '/api/kyc-form',
    KYC_SUBMIT: '/api/kyc-submit',
    KYC_DATA: '/api/kyc-data',
    DOWNLOAD_FILE: '/api/download-attachments',
    PAYMENT_METHODS: '/api/deposit/methods',
    PAYMENT_REQUEST: '/api/deposit/insert',
    DEPOSIT_HISTORY: '/api/deposit/history',
    MANUAL_DEPOSIT_CONFIRM: '/api/manual/confirm',
    SOCIAL_LOGIN: '/api/social-login',
    FCM_STORE_TOKEN: '/api/add-device-token',
    FCM_INSTRUCTOR_STORE_TOKEN: '/api/instructor/add-device-token',
    TRANSACTIONS: '/api/transactions',
    TICKETS: '/api/ticket',
    CREATE_TICKET: '/api/ticket/create',
    VIEW_TICKET: '/api/ticket/view',
    REPLY_TICKET: '/api/ticket/reply',
    CLOSE_TICKET: '/api/ticket/close',
    DOWNLOAD_TICKET_ATTACHMENT: '/api/ticket/download',
    CONTACT_US: '/api/contact',
    
    IPN: {
        stripe: '/ipn/stripe',
        authorize: '/ipn/authorize',
        nmi: '/ipn/nmi',
    },

    COOKIE: '/api/cookie',

    CUSTOM_PAGES: '/api/custom-pages',
    CUSTOM_PAGE: '/api/custom-page',
    SECTION_DATA: '/api/section-data',
    APP_VIEW_TICKET: '/api/ticket',
    APP_REPLY_TICKET: '/api/ticket/ticket-reply',
    ALL_SECTIONS: '/api/sections',
    BLOG_DETAILS: '/api/blog-details',
    SUBSCRIPTION: '/api/subscription',
    BLOGS: '/api/blogs',
    
    
    INSTRUCTOR_LOGIN: '/api/instructor/login',
    INSTRUCTOR_LOGOUT: '/api/instructor/logout',
    INSTRUCTOR_REGISTER: '/api/instructor/register',
    INSTRUCTOR_RESET_EMAIL: '/api/instructor/password/email',
    INSTRUCTOR_RESET_EMAIL_VERIFICATION: '/api/instructor/password/verify-code',
    INSTRUCTOR_RESET_PASSWORD: '/api/instructor/password/reset',
    UPDATE_INSTRUCTOR_DATA: '/api/instructor/data-submit',
    INSTRUCTOR_DASHBOARD:'/api/instructor/dashboard',
    PURCHASE_HISTORY: '/api/instructor/purchase-history',
    STUDENT_OVERVIEW: '/api/instructor/student-overview',
    INSTRUCTOR_KYC_FORM: '/api/instructor/kyc-form',
    INSTRUCTOR_KYC_SUBMIT: '/api/instructor/kyc-submit',
    INSTRUCTOR_KYC_DATA: '/api/instructor/kyc-data',
    INSTRUCTOR_SOCIAL_LOGIN: '/api/instructor/social-login',

    INSTRUCTOR_TWO_FA_SETUP: '/api/instructor/twofactor',
    INSTRUCTOR_TWO_FA_ENABLE: '/api/instructor/twofactor/enable',
    INSTRUCTOR_TWO_FA_DISABLE: '/api/instructor/twofactor/disable',
    INSTRUCTOR_TRANSACTIONS: '/api/instructor/transactions',


    WITHDRAW_HISTORY: '/api/instructor/withdraw/history',
    WITHDRAWAL_METHODS: '/api/instructor/withdraw-method',
    WITHDRAW_REQUEST: '/api/instructor/withdraw-request',
    WITHDRAW_CONFIRM: '/api/instructor/withdraw-request/confirm',
    REVIEW_LIST: '/api/instructor/review-list',
    REVIEW_REPLY:'/api/instructor/review-reply',


    INSTRUCTOR_TICKETS: '/api/instructor/ticket',
    INSTRUCTOR_CREATE_TICKET: '/api/instructor/ticket/create',
    INSTRUCTOR_VIEW_TICKET: '/api/instructor/ticket/view',
    INSTRUCTOR_REPLY_TICKET: '/api/instructor/ticket/reply',
    INSTRUCTOR_CLOSE_TICKET: '/api/instructor/ticket/close',
    INSTRUCTOR_DOWNLOAD_TICKET_ATTACHMENT: '/api/instructor/ticket/download',



    INSTRUCTOR_SEND_CODE: '/api/instructor/authorization',
    INSTRUCTOR_RESEND_CODE: '/api/instructor/resend-verify',
    INSTRUCTOR_VERIFY_CODE: '/api/instructor/verify',
    INSTRUCTOR_INFO: '/api/instructor/info',
    INSTRUCTOR_PROFILE_UPDATE:'/api/instructor/profile-setting',
    INSTRUCTOR_ACCOUNT:'/api/instructor/account-setting',
    INSTRUCTOR_CHANGE_PASSWORD:'/api/instructor/change-password',
    CATEGORIES: '/api/categories',



    CREATE_COURSE: '/api/instructor/course/create',
    CHECK_SLUG: '/api/instructor/course/check-slug',
    ADD_SECTION : '/api/instructor/course/add-section',
    ADD_LECTURE : '/api/instructor/course/add-lecture',
    ADD_LECTURE_VIDEO : '/api/instructor/course/add-lecture-video',
    ADD_LECTURE_ARTICLE : '/api/instructor/course/add-lecture-article',
    ADD_QUIZ:'/api/instructor/course/add-quiz',
    ADD_QUIZ_QUESTIONS:'/api/instructor/course/add-quiz-option',
    COURSE_DETAILS: '/api/instructor/course/details',
    COURSE_DELETE: '/api/instructor/course/delete',
    
    SECTION_DELETE:'/api/instructor/course/delete-section',
    LECTURE_DELETE:'/api/instructor/course/delete-lecture',
    QUIZ_DELETE:'/api/instructor/course/delete-quiz',
    QUESTION_DELETE:'/api/instructor/course/delete-question',
    ADD_CONTENT:'/api/instructor/course/save-content',
    ADD_PRICE:'/api/instructor/course/save-price',
    ADD_MESSAGE:'/api/instructor/course/save-message',
    ADD_INTENDED_LEARNERS:'/api/instructor/course/intended-learners',
    ADD_RESOURCES:'/api/instructor/course/save-resources',
    DELETE_RESOURCE:'/api/instructor/course/delete-resource',
    SUBMIT_COURSE:'/api/instructor/course/course-submit',
    COURSE_LIST:'/api/instructor/course/list',
    POPULAR_COURSE:'/api/popular-courses',
    DETAIL:'/api/course-detail',
    ENROLLED_COURSE:'/api/enrolled-courses',
    WATCH_COURSE:'/api/watch-course',
    COMPLETE_CURRICULUM:'/api/lecture-complete',
    QUIZ_VIEW:'/api/quiz-view',
    QUIZ_SUBMIT:'/api/quiz-submit',
    RESOURCES_DOWNLOAD:'/api/resource-download',
    GOALS:'api/goals',
    SAVE_GOAL:'api/save-goal',
    DASHBOARD:'api/dashboard',
    ALL_COURSES:'api/all-courses',
    USER_ACTIVITY:'/api/user-activity',
    TOP_COURSES:'/api/top-courses',
    SHORT_COURSES:'/api/short-courses',
    SUBMIT_REVIEW:'/api/review-submit',
    ACCOUNT_DELETE:'/api/delete-account',
    INSTRUCTOR_PROFILE:"/api/instructor-profile",
    COURSE_COMPLETE:"/api/course-complete", 
    GET_CERTIFICATE:"/api/download",
    APPLY_COUPON:"api/check-coupon",
    SAVE_KEYWORD:"/api/save-keyword",
    GET_KEYWORD:"/api/keyword",
    VERIFY_CERTIFICATE:"/api/verify-certificate",
    LATEST_COURSE:"/api/latest-course",
    INSTRUCTOR_RESOURCES_DOWNLOAD:'/api/instructor/course/download-resource',

}

export default ENDPOINTS